module.exports = __webpack_public_path__ + "static/media/s_v9_t8.b34fa11c.mp3";